// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  WorldOptions,
} from "./types";


export default __t.row({
  worldId: __t.u64().primaryKey().name("world_id"),
  phase: __t.u8(),
  get options() {
    return WorldOptions;
  },
  openedAt: __t.timestamp().name("opened_at"),
  begunAt: __t.option(__t.timestamp()).name("begun_at"),
});
